import { render, staticRenderFns } from "./DailyStatsComparisonReports.component.vue?vue&type=template&id=65f72353&scoped=true&"
import script from "./DailyStatsComparisonReports.component.vue?vue&type=script&lang=js&"
export * from "./DailyStatsComparisonReports.component.vue?vue&type=script&lang=js&"
import style0 from "./DailyStatsComparisonReports.component.vue?vue&type=style&index=0&id=65f72353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f72353",
  null
  
)

export default component.exports